import { useEffect, useState } from "react";
import api from "@/lib/api";
import { money, moneyClass, pct, cycleLabel } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";

const FILTERS = ["all", "accrued", "payable", "paid", "reversed"];

export default function Ledger() {
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = (f) => {
    const q = f && f !== "all" ? `?status=${f}` : "";
    api.get(`/events${q}`).then((r) => setEvents(r.data));
  };
  useEffect(() => { load(filter); }, [filter]);

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-black tracking-tight">Commission Ledger</h1>
        <p className="mt-1 text-sm text-muted-foreground">Single source of truth — every earned, paid, and reversed event. Immutable once paid.</p>
      </div>

      <div className="mb-4 flex gap-2">
        {FILTERS.map((f) => (
          <Button key={f} data-testid={`ledger-filter-${f}`} size="sm"
            variant={filter === f ? "default" : "outline"} onClick={() => setFilter(f)} className="capitalize">
            {f}
          </Button>
        ))}
      </div>

      <div className="overflow-hidden rounded-sm border border-border">
        <table className="w-full text-sm" data-testid="ledger-table">
          <thead className="bg-card"><tr className="border-b border-border">
            {["Rep", "Cycle", "Customer", "Product", "Sale", "Rate", "Commission", "Kind", "Source", "Status"].map((c, i) => (
              <th key={c} className={`px-4 py-3 overline ${[4, 5, 6].includes(i) ? "text-right" : "text-left"}`}>{c}</th>
            ))}
          </tr></thead>
          <tbody>
            {events.length === 0 && <tr><td colSpan={10} className="px-4 py-16 text-center text-sm text-muted-foreground">No events for this filter.</td></tr>}
            {events.map((e) => (
              <tr key={e.id} data-testid={`ledger-row-${e.id}`} className="border-b border-border hover:bg-accent transition-colors duration-200">
                <td className="px-4 py-2.5 font-medium">{e.rep_name}</td>
                <td className="px-4 py-2.5 font-mono">{cycleLabel(e.cycle)}</td>
                <td className="px-4 py-2.5">{e.customer}</td>
                <td className="px-4 py-2.5 text-muted-foreground">{e.product}</td>
                <td className="px-4 py-2.5 text-right font-mono">{money(e.sale_amount)}</td>
                <td className="px-4 py-2.5 text-right font-mono">{e.rate != null ? pct(e.rate * 100) : "flat"}</td>
                <td className={`px-4 py-2.5 text-right font-mono font-medium ${moneyClass(e.commission_amount)}`}>{money(e.commission_amount)}</td>
                <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">{e.kind}</td>
                <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">{e.payment_source || "—"}</td>
                <td className="px-4 py-2.5"><StatusBadge status={e.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
